module.exports = __webpack_public_path__ + "assets/vehicle-active.2fb13562.svg";